var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 7.65789L8.06266 18.7623C8.08992 19.1773 8.43451 19.5 8.85043 19.5H15.1496C15.5655 19.5 15.9101 19.1773 15.9373 18.7623L16.6667 7.65789M7.33333 7.65789H5M7.33333 7.65789H8.88889M16.6667 7.65789H19M16.6667 7.65789H15.1111M8.88889 7.65789V6.07895C8.88889 5.20692 9.59581 4.5 10.4678 4.5H13.5322C14.4042 4.5 15.1111 5.20692 15.1111 6.07895V7.65789M8.88889 7.65789H15.1111",
    stroke: "#2B323B",
    strokeWidth: 1.57895
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGrey);
export default __webpack_public_path__ + "static/media/deleteGrey.54865f7bd60079133d2b3256561a9a03.svg";
export { ForwardRef as ReactComponent };